export default {
  "isDebug": true,
  "debugUserInfo": {
    "qbid": "254bb6ba002ed8cd",
    "token": "33_KA6renIky7gOjGM3O3d34B1lir2kAqDX5f-x73BJIUhKnILTMuu-1ZZEhmSDKeqwtaiB0_Fm3P1Nr4SL9pJOcvShBk5VOt18PTa6kY2b9y0",
    "uin": "oXh-Rjr7RUZ153uF1ChXTRX5a5fM",
    "skey": "",
    "type": 2,
    "guid": "71bbd2de98db2168dce29cbf13b788cb",
    "integral": 0,
    "amount": 0,
    "nickname": "yukizou",
    "appid": "wx64f9cf5b17af074d",
    "head": "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLJYASkgP698QYicMgu5rSNKyJYMI3vEicO4w5ngMSVnRvJoeiaR7X71OffyGAPic4HHuCEkUSExXAudg/132"
  },
  "qua": "71bbd2de98db2168dce29cbf13b788cb",
  "QBFF_QA_URL": "https://h5.aisee.qq.com/index?appId=5951d0b63d&pid=1&data=cxuMLh%20Ssej2F5ZGRz9AZZYZmZt00Sdi14YvH7OT%20FtmRyynpvoqf0J6RZFVfFUvplYHf911hsFYn3pxFfzdD4clo7XiE0rkbzEwk9E4zWD4LDH%20r8HBi9tuvo%2FJjBuaQfpcQVt%20H1OQzZ7BYIpcmtfE0fpCT7HGMlm1PCtNVYVwvA29Dv4rCQJUgDGDvC64BD%2FtBxq4l3x0y6%2F5sA%2FWZB%20pt6r7FX0tKDTNCqhRolXLWj%20zvweanR29o%20RP07LfBYa98204ZXhYFiYs%20LMLlxCi%2F2n4p3XMeHWWv2HP2fTyXtNWtHR26AEIM7i%20c8DtMXBOWo9P2eVxtxGnMo2bpQ%3D%3D ",
  "qaid": "018645854726358A2294B80CF9C9ED77"
}
